<nb-card>
  <nb-accordion *ngIf='facilitySummary'>
    <nb-accordion-item class='facility'>
      <nb-accordion-item-header class='facility__header'>
        <div class='facility-name'>
          <div [nbTooltip]='notificationCounts()' class='facility-icon' nbTooltipPlacement='top'>
            <nb-icon
              class='{{ alertClass }}'
              icon='facility'
              nbPrefix
              pack='customIcons'
              status='control'
            ></nb-icon>
          </div>
          <div class='facility-details'>
            <div class='facility-details__name'>
              <div (click)='gotoFacilityDetails(facilitySummary.facility.id)'>
                <h6>
                  {{ facilitySummary.facility.name
                  }}<span
                >{{ facilitySummary.terminalCounts.total }}
                  {{ 'FACILITIES_SUMMARY.FACILITY.TERMINALS' | translate }}</span
                >
                </h6>
              </div>
            </div>
            <div class='terminal-counts'>
              <ng-container *ngIf='facilitySummary.terminalCounts.total === 0'>
                <span>{{ facilitySummary.terminalCounts.offline }} Online</span>
              </ng-container>
              <ng-container
                *ngIf='
                facilitySummary.terminalCounts.total > 0 &&
                  (alarmGoing() || alarmFromNotificationGoing()) &&
                  facilitySummary.terminalCounts.total === facilitySummary.terminalCounts.inUse;
                else offlineTemplate
              '
              >
                <app-alarm-led [ledConfig]="{ label: false, color: 'green' }"></app-alarm-led>
                <span>{{ 'FACILITIES_SUMMARY.FACILITY.ALL_ONLINE' | translate }}</span>
              </ng-container>
              <ng-template #offlineTemplate>
                <div *ngIf='facilitySummary.terminalCounts.offline > 0'>
                  <app-alarm-led [ledConfig]="{ label: false, color: 'red' }"></app-alarm-led>
                  <span
                  >{{ facilitySummary.terminalCounts.offline }}
                    {{ 'FACILITIES_SUMMARY.FACILITY.OFFLINE' | translate }}</span
                  >
                </div>
                <div *ngIf='facilitySummary.terminalCounts.outOfUse > 0'>
                  <app-alarm-led [ledConfig]="{ label: false, color: 'grey' }"></app-alarm-led>
                  <span
                  >{{ facilitySummary.terminalCounts.outOfUse }}
                    {{ 'FACILITIES_SUMMARY.FACILITY.OUT_OF_USE' | translate }}</span
                  >
                </div>
                <div *ngIf='facilitySummary.terminalCounts.inUse > 0'>
                  <app-alarm-led [ledConfig]="{ label: false, color: 'green' }"></app-alarm-led>
                  <span
                  >{{ facilitySummary.terminalCounts.inUse }}
                    {{ 'FACILITIES_SUMMARY.FACILITY.IN_USE' | translate }}</span
                  >
                </div>
              </ng-template>
            </div>
          </div>
        </div>
        <div>
          <ng-container>
            <div class='alarms'>
              <app-facility-emergency-alarms
                (click)='gotoFacilityDetails(facilitySummary.facility.id)'
                *ngIf='facilitySummary.facility.id'
                [alarmsFromSummary]='facilitySummary.emergencyAlarms'
                [facilityId]='facilitySummary.facility.id'
                [showHeaderIcon]='false'
              ></app-facility-emergency-alarms>
              <div class='facility-navigation'>
                <a
                  (click)='gotoFacilityDetails(facilitySummary.facility.id)'
                  [routerLink]="['/status/facilities', facilitySummary.facility.id]"
                >
                  <nb-icon
                    class='icon-navigate'
                    icon='arrow-ios-forward'
                    nbPrefix
                    pack='eva'
                    status='control'
                  ></nb-icon>
                </a>
              </div>
            </div>
          </ng-container>
        </div>
      </nb-accordion-item-header>
      <nb-accordion-item-body>
        <div class='facility-summary'>
          <div>
            <app-occupation-ratios [facilitySummary]='facilitySummary'></app-occupation-ratios>
          </div>
          <div></div>
        </div>
      </nb-accordion-item-body>
    </nb-accordion-item>
  </nb-accordion>
</nb-card>
